export const ProfileActionTypes = {
    OPEN_PROFILE_PAGE: 'OPEN_PROFILE_PAGE',
    CLOSE_PROFILE_PAGE: 'CLOSE_PROFILE_PAGE',
};